





















import {Component, Vue} from 'vue-property-decorator';
import Knobs from '@/components/Knobs.vue';
import NumberToStringConverter from '@/components/NumberToStringConverter.vue';
import StringToNumberConverter from '@/components/StringToNumberConverter.vue';
import HexDumpSieve from '@/components/HexDumpSieve.vue';

@Component({
    components: {
        HexDumpSieve: HexDumpSieve,
        Knobs,
        NumberToStringConverter,
        StringToNumberConverter,
    },
})
export default class App extends Vue {
}
